<template>
  <div class="container">
    <headers ref="headers" @change="changetype"></headers>
    <right></right>
    <scrollpage></scrollpage>

    <div class="w box_sizing width_box my_wrap">
      <div class="left_position">
        <left></left>
      </div>
      <div>
        <div class="type_title">实时高频</div>
        <el-tabs v-model="activeName" ref="myTabs" type="border-card" @tab-click="handleClick" :before-leave="beforeLeave">
          <el-tab-pane label="PTE Academic" name="first">
            <div class="my_practice_wrap box_sizing">
              <div class="practice_top box_sizing flex_box flex_justify_between flex_align_center">
                <div class="practice_list box_sizing flex_box flex_justify_between flex_align_center" @click="typeChange(0)">
                  <div class="practice_list_left flex_box flex_justify_center flex_align_center" :class="[type == 0 ? 'now' : '']">
                    <img :src="
                        type == 0
                          ? require('../assets/images/icon002.png')
                          : require('../assets/images/icon001.png')
                      " class="practice_list_left_icon" alt="" />
                  </div>
                  <div class="practice_list_right" :class="[type == 0 ? 'now' : '']">
                    全部
                  </div>
                </div>
                <div class="practice_list box_sizing flex_box flex_justify_between flex_align_center" @click="typeChange(1)">
                  <div class="practice_list_left flex_box flex_justify_center flex_align_center" :class="[type == 1 ? 'now' : '']">
                    <img :src="
                        type == 1
                          ? require('../assets/images/icon004.png')
                          : require('../assets/images/icon003.png')
                      " class="practice_list_left_icon" alt="" />
                  </div>
                  <div class="practice_list_right" :class="[type == 1 ? 'now' : '']">
                    口语
                  </div>
                </div>
                <div class="practice_list box_sizing flex_box flex_justify_between flex_align_center" @click="typeChange(2)">
                  <div class="practice_list_left flex_box flex_justify_center flex_align_center" :class="[type == 2 ? 'now' : '']">
                    <img :src=" type == 2 ? require('../assets/images/icon006.png'): require('../assets/images/icon005.png')" class="practice_list_left_icon" alt="" />
                  </div>
                  <div class="practice_list_right" :class="[type == 2 ? 'now' : '']">
                    写作
                  </div>
                </div>
                <div class="practice_list box_sizing flex_box flex_justify_between flex_align_center" @click="typeChange(3)">
                  <div class="practice_list_left flex_box flex_justify_center flex_align_center" :class="[type == 3 ? 'now' : '']">
                    <img :src="
                        type == 3
                          ? require('../assets/images/icon008.png')
                          : require('../assets/images/icon007.png')
                      " class="practice_list_left_icon" alt="" />
                  </div>
                  <div class="practice_list_right" :class="[type == 3 ? 'now' : '']">
                    阅读
                  </div>
                </div>
                <div class="practice_list box_sizing flex_box flex_justify_between flex_align_center" @click="typeChange(4)">
                  <div class="practice_list_left flex_box flex_justify_center flex_align_center" :class="[type == 4 ? 'now' : '']">
                    <img :src="
                        type == 4
                          ? require('../assets/images/icon010.png')
                          : require('../assets/images/icon009.png')
                      " class="practice_list_left_icon" alt="" />
                  </div>
                  <div class="practice_list_right" :class="[type == 4 ? 'now' : '']">
                    听力
                  </div>
                </div>
              </div>

              <div class="practice_box box_sizing">
                <div class="practice_list_wrap" v-for="(item, index) in list" :key="'list' + index">
                  <div class="practice_list_box_top" v-if="item.child.length != 0">
                    <div class="practice_list_top_en">{{ item.en_name }}</div>
                    <div class="practice_list_top_title">{{ item.name }}</div>
                    <div class="practice_list_top_line"></div>
                  </div>
                  <div class="practice_list_box box_sizing flex_box flex-warp">
                    <div class="practice_item box_sizing" v-for="(items, indexs) in item.child" :key="'items' + indexs" @click="jumpList(items)" :style="
                        'background:url(' +
                        item.bg +
                        ') no-repeat left top;background-size: 100% 100%;-webkit-background-size: 100% 100%;'
                      ">
                      <div class="practic_item_top box_sizing flex_box flex_align_center">
                        <div class="practic_item_label box_sizing flex_box flex_justify_center flex_align_center">
                          {{ items.short_name }}
                        </div>
                        <div class="practic_item_title">{{ items.name }}</div>
                      </div>
                      <div class="practice_item_list">
                        题 量： {{ items.topic_count }}
                      </div>
                      <div class="practice_item_list">
                        学习次数： {{ items.topic_exercise_count }}
                      </div>
                      <div class="practice_item_list">
                        考试分值： {{ items.score }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="PTE CORE" name="second">
            <div class="my_practice_wrap box_sizing">
              <div class="practice_top box_sizing flex_box flex_justify_between flex_align_center">
                <div class="practice_list box_sizing flex_box flex_justify_between flex_align_center" @click="typeChange(0)">
                  <div class="practice_list_left flex_box flex_justify_center flex_align_center" :class="[type == 0 ? 'now' : '']">
                    <img :src="
                        type == 0
                          ? require('../assets/images/icon002.png')
                          : require('../assets/images/icon001.png')
                      " class="practice_list_left_icon" alt="" />
                  </div>
                  <div class="practice_list_right" :class="[type == 0 ? 'now' : '']">
                    全部
                  </div>
                </div>
                <div class="practice_list box_sizing flex_box flex_justify_between flex_align_center" @click="typeChange(6)">
                  <div class="practice_list_left flex_box flex_justify_center flex_align_center" :class="[type == 6 ? 'now' : '']">
                    <img :src="
                        type == 6
                          ? require('../assets/images/icon004.png')
                          : require('../assets/images/icon003.png')
                      " class="practice_list_left_icon" alt="" />
                  </div>
                  <div class="practice_list_right" :class="[type == 6 ? 'now' : '']">
                    口语
                  </div>
                </div>
                <div class="practice_list box_sizing flex_box flex_justify_between flex_align_center" @click="typeChange(7)">
                  <div class="practice_list_left flex_box flex_justify_center flex_align_center" :class="[type == 7 ? 'now' : '']">
                    <img :src=" type == 7 ? require('../assets/images/icon006.png'): require('../assets/images/icon005.png')" class="practice_list_left_icon" alt="" />
                  </div>
                  <div class="practice_list_right" :class="[type == 7 ? 'now' : '']">
                    写作
                  </div>
                </div>
                <div class="practice_list box_sizing flex_box flex_justify_between flex_align_center" @click="typeChange(8)">
                  <div class="practice_list_left flex_box flex_justify_center flex_align_center" :class="[type == 8 ? 'now' : '']">
                    <img :src="
                        type == 8
                          ? require('../assets/images/icon008.png')
                          : require('../assets/images/icon007.png')
                      " class="practice_list_left_icon" alt="" />
                  </div>
                  <div class="practice_list_right" :class="[type == 8 ? 'now' : '']">
                    阅读
                  </div>
                </div>
                <div class="practice_list box_sizing flex_box flex_justify_between flex_align_center" @click="typeChange(9)">
                  <div class="practice_list_left flex_box flex_justify_center flex_align_center" :class="[type == 9 ? 'now' : '']">
                    <img :src="
                        type == 9
                          ? require('../assets/images/icon010.png')
                          : require('../assets/images/icon009.png')
                      " class="practice_list_left_icon" alt="" />
                  </div>
                  <div class="practice_list_right" :class="[type == 9 ? 'now' : '']">
                    听力
                  </div>
                </div>
              </div>

              <div class="practice_box box_sizing">
                <div class="practice_list_wrap" v-for="(item, index) in list_c" :key="'list' + index">
                  <div class="practice_list_box_top" v-if="item.child.length != 0">
                    <div class="practice_list_top_en">{{ item.en_name }}</div>
                    <div class="practice_list_top_title">{{ item.name }}</div>
                    <div class="practice_list_top_line"></div>
                  </div>
                  <div class="practice_list_box box_sizing flex_box flex-warp">
                    <div class="practice_item box_sizing" v-for="(items, indexs) in item.child" :key="'items' + indexs" @click="jumpList(items)" :style="
                        'background:url(' +
                        item.bg +
                        ') no-repeat left top;background-size: 100% 100%;-webkit-background-size: 100% 100%;'
                      ">
                      <div class="practic_item_top box_sizing flex_box flex_align_center">
                        <div class="practic_item_label box_sizing flex_box flex_justify_center flex_align_center">
                          {{ items.short_name }}
                        </div>
                        <div class="practic_item_title">{{ items.name }}</div>
                      </div>
                      <div class="practice_item_list">
                        题 量： {{ items.topic_count }}
                      </div>
                      <div class="practice_item_list">
                        学习次数： {{ items.topic_exercise_count }}
                      </div>
                      <div class="practice_item_list">
                        考试分值： {{ items.score }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <el-dialog
      title="请选择你的练习类型"
      :visible.sync="centerDialogVisible"
      width="520px"
      center>
      <div style="font-size: 16px;font-weight: bold;">
        PTE Academic / UKVI:
      </div>
      <div>
        用于全球大学申请，澳大利亚、新西兰的移民或工作等各类签证申请，英国工作或学生签证申请
      </div>
      <div style="font-size: 16px;font-weight: bold;margin-top: 30px;">
        PTE Core:
      </div>
      <div>用于加拿大移民或工作签证申请</div>
      <div class="dialog-body">
        <el-button class="btn_change" type="primary" @click="chooseType('first')">PTE Academic / UKVI</el-button>
        <el-button class="btn_change" type="primary" @click="chooseType('second')">PTE Core</el-button>
      </div>
    </el-dialog>

    <footers></footers>
  </div>
</template>

<script>
import headers from "@/components/headers";
import footers from "@/components/footders";
import left from "@/components/left";
import right from "@/components/right";
import scrollpage from "@/components/scrollpage";
import "@/css/practice.css";
import { mapState, mapMutations, mapActions, mapGetters } from "vuex"

var _this;
export default {
  components: {
    headers,
    footers,
    left,
    right,
    scrollpage,
  },
  data() {
    return {
      type: 0,
      list: [], //题型列表
      list_c: [], //题型列表
      listAll: [], // PTE Academic 全量题型列表（用于前端切换过滤）
      listCAll: [], // PTE Core 全量题型列表（用于前端切换过滤）
      alltype: [], //分类列表
      activeName: localStorage.getItem('activeName') ? localStorage.getItem('activeName') : 'first',
      centerDialogVisible: false,
      allow_change: 0
    };
  },
    computed: {
        ...mapState(['nickname', 'avatar', 'choose_type']),
    },
  created() {
    _this = this;
    _this.getlist();
    // _this.getTypeList();
  },
  mounted(){
    console.log('choose_type',_this.choose_type);
    // if(_this.choose_type == 0) {
    //   _this.centerDialogVisible = true;
    // }
    if(localStorage.getItem('choose_type') === 0) {
      _this.centerDialogVisible = true;
    }
     _this.$refs.headers.changeIsParent(1);
  },
  methods: {
			...mapActions(["userchoosetype"]),
    getlist() {
      _this = this;
      _this.type = _this.$route.query.id || 0;
      _this.typelist();
      console.log(_this.$route.query.id, 'id')
    },
    handleClick(tab, event) {
      _this.centerDialogVisible = true;
      console.log(tab, event);
    },
    // 通过 DOM 触发点击
    simulateTabClick(tabName) {
      const tabs = this.$refs.myTabs;
      console.log('324y893csd,mfnmsdf',tabs);
      const tabElements = tabs.$el.querySelectorAll('.el-tabs__item'); // 标签头元素
      console.log('sd;lkfsfksjfsfksskdf908098',tabElements);
      tabElements.forEach((tabEl, index) => {
        if (tabs.panes[index].name === tabName) {
          tabEl.click(); // 触发点击事件
        }
      });
    },
    beforeLeave(new_active, old_active){
      console.log(new_active,old_active);
      if(_this.allow_change == 1) {
        _this.allow_change = 0;
        return true;
      } else {
        return false;
      }
    },

    chooseType(activeName){
      _this.centerDialogVisible = false
      if(activeName != _this.activeName) {
        localStorage.setItem('activeName',activeName);
        _this.$refs.headers.pratice_type = activeName=='first'?'PTE A':'PTE Core';
        _this.activeName = activeName
        _this.allow_change = 1;
        console.log(_this.activeName,activeName);
        _this.type = 0;
        _this.typelist()
      }
      _this.userchoose(activeName=='first'?1:2);
    },
    changetype(type){
      console.log('type',type);
      if(type == -1) {
        _this.simulateTabClick(_this.activeName);
      } else {
        _this.activeName = type
      }
    },

    // typechange  切换type
    typeChange(type) {
      _this.type = type;
      _this.applyTypeFilter();
    },

    /**
     * 根据当前顶部分类 type，从全量列表中过滤出需要展示的数据
     * @returns {void} 无返回值，直接更新 list 或 list_c
     */
    applyTypeFilter() {
      const isCore = _this.activeName !== 'first'
      const sourceList = isCore ? _this.listCAll : _this.listAll

      // 全部：展示所有分组
      if (_this.type === 0) {
        if (isCore) {
          _this.list_c = sourceList
        } else {
          _this.list = sourceList
        }
        return
      }

      const filtered = _this.filterPracticeGroupList(sourceList, _this.type, isCore)
      if (isCore) {
        _this.list_c = filtered
      } else {
        _this.list = filtered
      }
    },

    /**
     * 将顶部分类 type 映射为分类关键字
     * @param {Number} type - 顶部分类值
     * @param {Boolean} isCore - 是否为 PTE Core
     * @returns {{zh: String, en: String, index: Number}} 分类关键字与兖底索引
     */
    getPracticeCateKey(type, isCore) {
      const academicMap = {
        1: { zh: '口语', en: 'speaking', index: 0 },
        2: { zh: '写作', en: 'writing', index: 1 },
        3: { zh: '阅读', en: 'reading', index: 2 },
        4: { zh: '听力', en: 'listening', index: 3 }
      }
      const coreMap = {
        6: { zh: '口语', en: 'speaking', index: 0 },
        7: { zh: '写作', en: 'writing', index: 1 },
        8: { zh: '阅读', en: 'reading', index: 2 },
        9: { zh: '听力', en: 'listening', index: 3 }
      }
      return (isCore ? coreMap : academicMap)[type] || { zh: '', en: '', index: -1 }
    },

    /**
     * 过滤题型分组列表，仅保留指定分类分组（口语/写作/阅读/听力）
     * @param {Array} groups - 全量分组列表
     * @param {Number} type - 顶部分类值
     * @param {Boolean} isCore - 是否为 PTE Core
     * @returns {Array} 过滤后的分组列表
     */
    filterPracticeGroupList(groups, type, isCore) {
      if (!Array.isArray(groups) || groups.length === 0) {
        return []
      }
      const key = _this.getPracticeCateKey(type, isCore)
      // 1) 优先按 id/cate_id/topic_cate_id 等字段匹配（如果后端返回有）
      const idMatched = groups.filter((g) => {
        if (!g) return false
        const id = g.id || g.cate_id || g.topic_cate_id
        return id !== undefined && id !== null && String(id) === String(type)
      })
      if (idMatched.length > 0) {
        return idMatched
      }
      // 2) 再按名称匹配（中英文都尝试）
      const nameMatched = groups.filter((g) => {
        if (!g) return false
        const zh = (g.name || '').toString()
        const en = (g.en_name || '').toString().toLowerCase()
        return (key.zh && zh.includes(key.zh)) || (key.en && en.includes(key.en))
      })
      if (nameMatched.length > 0) {
        return nameMatched
      }
      // 3) 兖底：按常见顺序索引
      if (key.index >= 0 && groups[key.index]) {
        return [groups[key.index]]
      }
      return []
    },
    // 修改状态
    userchoose(choose_type){
      var params = {
        choose_type: choose_type
      };
      _this.$axios
        .post("user/profile", params)
        .then((res) => {
          console.log(res);
          if (res.code == 1) {
            // _this.userchoosetype(choose_type)
            localStorage.setItem('choose_type',choose_type)
            console.log('choose_type_new',_this.choose_type);
          } else {
            _this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    /**
     * 获取题型列表（默认接口不变：请求全量数据；分类切换仅做前端过滤）
     * @returns {void} 无返回值
     */
    typelist() {
      console.log(this.type, 'type')
      var params = {
        topic_cate_id: 0,
        is_high: 1,
        type: _this.activeName == 'first' ? 1 : 2
      };
      _this.$axios
        .post("exercise.topic_type/getTypeList", params)
        .then((res) => {
          console.log(res);
          if (res.code == 1) {
            res.data.pte_a.forEach((item, index) => {
              let x = index * 1 + 1;
              item.bg = require("../assets/images/bg_img0" + x + ".png");
            });
            res.data.pte_c.forEach((item, index) => {
              let x = index * 1 + 1;
              item.bg = require("../assets/images/bg_img0" + x + ".png");
            });
            _this.listAll = res.data.pte_a;
            _this.listCAll = res.data.pte_c;
            _this.applyTypeFilter();
          } else {
            _this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    // 获取题型列表
    // getTypeList() {
    //   _this.$axios
    //     .post("exercise.topic_type/getTypeList", {})
    //     .then((res) => {
    //       console.log(res);
    //       if (res.code == 1) {
    //         res.data.forEach((item, index) => {
    //           let x = index * 1 + 1;
    //           item.bg = require("../assets/images/bg_img0" + x + ".png");
    //         });
    //         _this.list = res.data;
    //       } else {
    //         _this.$message.error(res.msg);
    //       }
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //     });
    // },

    // 跳转练习题列表
    jumpList(obj) {
      // _this.$router.push({
      //     path: '/questionList?id=' + id
      // })
      _this.$router.push({
        path: "/questionList",
        query: {
          id: obj.id,
          name: obj.name,
          type: 1
        },
      });
    },
  },
};
</script>


<style></style>


